import React, { useCallback, useState } from 'react'
import className from 'classnames/bind'

import style from './MyhouseImageAttach.module.scss'

import SvgMyhouseEnrolImage from '@Root/ui/images/myhouse/myhouse_enrol--image.svg'
import IconDelete26x26 from '@Root/ui/images/myhouse/IconDelete26x26.svg'
import { ARTICLE_IMAGE_ACCEPT_TYPE } from '@Root/contants/myhouseRegister'
import { BOARD_IMAGE_MAX_COUNT, BOARD_IMAGE_MAX_MB_SIZE, MY_HOUSE_BOARD_TYPE } from '@Root/contants/myhouse'
import useModal from '@Hooks/myhouse/useModal'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import ArrowTooltip from '@Ui/images/myhouse/ArrowTooltip.svg'
import IconCloseTooltip from '@Ui/images/myhouse/IconCloseTooltip.svg'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  previewURLs: string[]
  handleImageChange: any
  handleRemoveClick: any
  isTooltip?: boolean
  setIsTooltip?: (isTooltip: boolean) => void
  fileSize: number
  boardType: MY_HOUSE_BOARD_TYPE
}

const MyhouseImageAttach: React.FC<Props> = ({ previewURLs, handleImageChange, handleRemoveClick, isTooltip, setIsTooltip, fileSize, boardType }: Props) => {
  const total = previewURLs?.length || 0
  const fileSizeText = `${(fileSize / 1024 / 1024).toFixed(1)}MB`
  const { open } = useModal()
  const maxCountCheck = (e: React.SyntheticEvent) => {
    handleNclick(boardType === MY_HOUSE_BOARD_TYPE.NOTICE ? NCLICK.MY_HOUSE.NOTICE_ENROL.IMAGE_ATTACH : NCLICK.MY_HOUSE.REVIEW_ENROL.IMAGE_ATTACH, e)

    if (total >= BOARD_IMAGE_MAX_COUNT) {
      e.preventDefault()
      e.stopPropagation()
      open(MODAL_TYPE.MAX_PHOTO_COUNT)
      return
    }

    if (fileSize >= BOARD_IMAGE_MAX_MB_SIZE * 1024 * 1024) {
      e.preventDefault()
      e.stopPropagation()
      open(MODAL_TYPE.MAX_PHOTO_SIZE)
    }
  }

  const handleTooltipClose = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault()
    e.stopPropagation()
    handleNclick(NCLICK.MY_HOUSE.NOTICE_ENROL.IMAGE_TOOLTIP_CLOSE, e)

    setIsTooltip && setIsTooltip(false)
    localStorage.setItem('myhouse:bbs:attach:tooltip:close', 'Y')
  }, [])

  const onImageChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      handleImageChange(e)
      setIsTooltip && setIsTooltip(false)
    },
    [handleImageChange],
  )

  return (
    <>
      <div className={cx('article')}>
        <div className={cx('scroll')}>
          {previewURLs &&
            previewURLs.map((imageUrl: string, index: number) => (
              <span className={cx('item')} key={index}>
                <span className={cx('image')} style={{ backgroundImage: `url(${imageUrl})` }}></span>
                <button type="button" className={cx('delete')} aria-label="삭제하기" onClick={handleRemoveClick(index)}>
                  <IconDelete26x26 />
                </button>
              </span>
            ))}
          <span className={cx('item')}>
            <input id="input_image" type="file" className={cx('input')} onClick={maxCountCheck} onChange={onImageChange} multiple={true} accept={ARTICLE_IMAGE_ACCEPT_TYPE} />
            <label htmlFor="input_image" className={cx('label')}>
              <SvgMyhouseEnrolImage />
              <span className={cx('text')}>사진첨부</span>
            </label>
          </span>
          {isTooltip && (
            <span className={cx('tooltip')}>
              내용 없이 사진만 첨부해도
              <br />
              공지사항을 등록할 수 있어요!
              <ArrowTooltip />
              <button type="button" className={cx('button_close')} onClick={handleTooltipClose}>
                <IconCloseTooltip />
                <span className="blind">닫기</span>
              </button>
            </span>
          )}
        </div>
        <div className={cx('bytes')}>
          {total}장({fileSizeText}){' '}
          <span className={cx('total')}>
            / {BOARD_IMAGE_MAX_COUNT}장({BOARD_IMAGE_MAX_MB_SIZE}MB)
          </span>
        </div>
      </div>
    </>
  )
}

export default MyhouseImageAttach
